import * as angular from "angular";
import {SplitService} from "../commons/services/split-service.service";
import {ViewFilterSettingsService} from "../commons/services/view-filter-settings.service";
import {DateRangeTimeFiltersService} from "../commons/services/date-range-time-filters.service";
import {CommonsService} from "../commons/services/commons-service.service";
import {DateRangeContextService} from "../commons/services/date-range-context.service";
import {SettingsService} from "../site-preferences/services/settings-service.service";

angular
  .module('bringoz.admin.threePL')
  .config(threePLConfig);

/* @ngInject */
function threePLConfig($stateProvider) {

  $stateProvider

    //ThreePL
    .state('threePL', {
      parent: 'bringoz.site',
      abstract: true,
      url: '/threePL',
      template: '<ui-view class="full-height"></ui-view>'
    })

    //ThreePL - Train
    .state('threePL.train', {
      abstract: true,
      url: '/train',
      template: '<ui-view class="full-height"></ui-view>'
    })

    .state('threePL.train.vouchers', {
      url: '/vouchers?:from&:to&:voucherId&:serviceId',
      pageTrack: '/dispatch/vouchers',
      template: '<app-threepl-train-vouchers-view [from]="vm.from" [to]="vm.to" [voucher-id]="vm.voucherId" [service-id]="vm.serviceId"></app-threepl-train-vouchers-view>',
      controllerAs: 'vm',
      controller: function ($stateParams, triBreadcrumbsService) {
        if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from);
          this.to = parseInt($stateParams.to);
        }
        this.voucherId = $stateParams.voucherId;
        this.serviceId = $stateParams.serviceId;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Vouchers"});
        triBreadcrumbsService.addCrumb({name: 'Dispatch'});
      }
    })


    // ThreePL - Create Voucher
    .state('threePL.train.create-voucher', {
      url: '/create-voucher?:stepsIds',
      pageTrack: '/account/demand/new-order',
      template: '<app-threepl-create-train-voucher-view></app-threepl-create-train-voucher-view>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Create Voucher"});
        triBreadcrumbsService.addCrumb({name: "Train"});
        triBreadcrumbsService.addCrumb({name: "Three PL"});
        triBreadcrumbsService.addCrumb({name: 'Administration'});
      },
    })

    .state('threePLServices', {
      parent: 'bringoz.site',
      url: '/threePl-services',
      abstract: true,
      template: '<ui-view>'
    })
    .state('threePLServices.table', {
      controllerAs: 'vm',
      url: '/table?:from&:to&:accountIds&:branchIds&:depotsIds&:areaIds&:providerTypes&:group&:dateRangeTemplateType&:supplyAccountIds&:programTypes&:serviceTypes',
      template: '<app-threepl-services-view [from]="vm.from" [to]="vm.to" [account-ids]="vm.accountIds" [branch-ids]="vm.branchIds" [depot-ids]="vm.depotsIds"' +
        ' [service-area-ids]="vm.serviceAreaIds" [provider-types]="vm.providerTypes" [program-types]="vm.programTypes" [group]="vm.group" [selected-quick-filter-id]="vm.selectedQuickFilterId" ' +
        '[date-range-template-type]="vm.dateRangeTemplateType" [supply-account-ids]="vm.supplyAccountIds" [service-types]="vm.serviceTypes"></app-threepl-services-view>',
      controller: function ($stateParams, dateRangeTimeFiltersService: DateRangeTimeFiltersService,
                            commonsService: CommonsService, triBreadcrumbsService, viewFilterSettingsService: ViewFilterSettingsService,
                            splitService: SplitService, dateRangeContextService: DateRangeContextService, metadataSettings, $state, site) {

        const threePlServicesSettings = splitService.getSite3plServiceSettings(site.id);

        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);
        const dateRange = dateRangeContextService.getRange();

        this.dateRangeTemplateType = $stateParams.dateRangeTemplateType || quickActiveFilter?.settings.dateRangeTemplateType || viewFilterSettingsService.getDateRangeTemplateType();

        if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from)
          this.to = parseInt($stateParams.to);
        } else if (this.dateRangeTemplateType) {
          const dateRangeFilter = dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType);
          this.from = dateRangeFilter.dateStart;
          this.to = dateRangeFilter.dateEnd;
        } else if (!!dateRange.from && !!dateRange.to) {
          this.from = dateRange.from;
          this.to = dateRange.to;
        }


        this.selectedQuickFilterId = quickActiveFilter?.id;
        this.group = $stateParams.group || threePlServicesSettings.defaultGroup;
        this.accountIds = commonsService.parseArrayStateParam($stateParams.accountIds) || quickActiveFilter?.settings.accountIds || viewFilterSettingsService.getAccountIds() || [];
        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds) || quickActiveFilter?.settings.branchIds || viewFilterSettingsService.getBranchIds() || [];
        this.supplyAccountIds = commonsService.parseArrayStateParam($stateParams.supplyAccountIds) || quickActiveFilter?.settings.supplyAccountIds;
        this.serviceAreaIds = commonsService.parseArrayStateParam($stateParams.serviceAreaIds) || quickActiveFilter?.settings.serviceAreaIds || viewFilterSettingsService.getServiceAreaIds() || [];
        this.depotIds = commonsService.parseArrayStateParam($stateParams.depotIds) || quickActiveFilter?.settings.depotIds;
        this.providerTypes = commonsService.parseArrayStateParam($stateParams.providerTypes) || quickActiveFilter?.settings.providerTypes;
        this.programTypes = commonsService.parseArrayStateParam($stateParams.programTypes) || quickActiveFilter?.settings.programTypes;
        this.serviceTypes = $stateParams.serviceTypes ? commonsService.parseArrayStateParam($stateParams.serviceTypes) : quickActiveFilter?.settings.serviceTypes || [];

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Table"});
        triBreadcrumbsService.addCrumb({name: "ThreePL Services", state: "threePLServices.table"});
        triBreadcrumbsService.addCrumb({name: "Dispatch"});
      },
      resolve: {
        metadataSettings: function (settingsService: SettingsService, site) {
          return settingsService.getSiteMetadata();
        }
      }
    })

    .state('threePLService', {
      parent: 'bringoz.site',
      url: '/threePl-service/:id',
      abstract: true,
      template: '<ui-view class="full-height"></ui-view>',
      resolve: {
        metadataSettings: function (settingsService: SettingsService, site) {
          return settingsService.getSiteMetadata();
        }
      }
    })
    .state('threePLService.info', {
      url: '',
      controllerAs: 'vm',
      template: '<app-threepl-service-view [service-id]="vm.serviceId"></app-threepl-service-view>',
      controller: function (triBreadcrumbsService, $stateParams) {

        this.serviceId = $stateParams.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: $stateParams.id, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "ThreePL Services", state: "threePLServices.table"});
      }
    })

}
